import axios from 'axios';

const API_URL = 'http://localhost:5000/api/about';

export const getAboutContent = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching about content:', error);
        throw error;
    }
};

export const createAboutContent = async (aboutData) => {
    try {
        const response = await axios.post(API_URL, aboutData);
        return response.data;
    } catch (error) {
        console.error('Error creating about content:', error);
        throw error;
    }
};

export const updateAboutContent = async (id, aboutData) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, aboutData);
        return response.data;
    } catch (error) {
        console.error('Error updating about content:', error);
        throw error;
    }
};

export const deleteAboutContent = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting about content:', error);
        throw error;
    }
}; 